import api from './api';

/**
 * Zentral gepflegte Einstellungswerte.
 *
 * Der KANUE-Jahresarbeitsstundenwert liegt als genau ein Datensatz in der Datenbank
 * (Plan 20-09): die Ressource kennt weder Sammelabfrage noch Anlegen oder Loeschen,
 * nur `GET` und `PATCH` auf dem Datensatz mit der festen `id` 1. Deshalb steht die
 * vollstaendige URI hier als eine Konstante und wird nicht ueber die Datei verstreut,
 * und die Funktionen nehmen keinen `id`-Parameter entgegen.
 */
const ANNUAL_WORKING_HOURS_PATH = '/api/annual_working_hours_settings/1';

/** Der Einstellungsdatensatz, wie ihn die API liefert. */
export interface AnnualWorkingHoursSetting {
  id: number;
  /** DECIMAL(14,2) — die API liefert und erwartet einen String, keine Zahl. */
  annualHours: string;
}

export const settingsApi = {
  getAnnualWorkingHours: async (): Promise<AnnualWorkingHoursSetting> => {
    const response = await api.get<AnnualWorkingHoursSetting>(ANNUAL_WORKING_HOURS_PATH);
    return response.data;
  },

  updateAnnualWorkingHours: async (annualHours: string): Promise<AnnualWorkingHoursSetting> => {
    const response = await api.patch<AnnualWorkingHoursSetting>(
      ANNUAL_WORKING_HOURS_PATH,
      { annualHours },
      { headers: { 'Content-Type': 'application/merge-patch+json' } },
    );
    return response.data;
  },
};
